<template>
  <div class="float-btns">
    <ul class="float-btns-container">
      <li v-for="(item, key) in gameType" :key="key" class="float-btn-item" @click="$emit('selectGameType', item)">
        <div class="float-btn-img">
          <img :src="item.image_small" alt="">
        </div>
        <div class="float-btn-text">
          {{ item.name }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  computed: {
    gameType() {
      return this.$store.getters.gameType
    }
  }
}
</script>
